import { render } from "./DynamicForm.vue?vue&type=template&id=21999e68&scoped=true&ts=true"
import script from "./DynamicForm.vue?vue&type=script&lang=ts"
export * from "./DynamicForm.vue?vue&type=script&lang=ts"

import "./DynamicForm.vue?vue&type=style&index=0&id=21999e68&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21999e68"]])

export default __exports__